import { render, staticRenderFns } from "./Redireccion.vue?vue&type=template&id=cd899224&scoped=true"
import script from "./Redireccion.vue?vue&type=script&lang=js"
export * from "./Redireccion.vue?vue&type=script&lang=js"
import style0 from "./Redireccion.vue?vue&type=style&index=0&id=cd899224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd899224",
  null
  
)

export default component.exports